import { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const links = ['About', 'Services', 'Work', 'Contact'];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0f0f10]/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-10 py-5">
        <a href="#" className="cursor-pointer flex items-center gap-1 group">
          <span className="font-display text-2xl text-[#ff5a3d] leading-none tracking-tight group-hover:tracking-wide transition-all">
            VSK
          </span>
          <span className="w-2 h-2 rounded-full bg-[#ff5a3d] animate-blink mt-2" />
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <li key={l}>
              <a
                href={`#${l.toLowerCase()}`}
                className="cursor-pointer text-sm text-[#f5f0e6]/80 hover:text-[#f5f0e6] transition-colors relative group whitespace-nowrap"
              >
                {l}
                <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-[#ff5a3d] transition-all duration-300 group-hover:w-full" />
              </a>
            </li>
          ))}
        </ul>

        <button className="md:hidden w-10 h-10 flex items-center justify-center text-[#f5f0e6] cursor-pointer">
          <i className="ri-menu-line text-xl" />
        </button>
      </nav>
    </header>
  );
}